import api from "@/lib/axios";

export const batchSerice = {
  // Get all campaigns
  getBatches: async (batchId, heartbeat = {}) => {
    try {
      // error response is {"error":"Your pre-screen message has expired. Please start a new batch."}
      const { data } = await api.get(`/batch/${batchId}`, {
        params: heartbeat,
      });
      // Mock error response
      // return { error: "Your pre-screen message has expired. Please start a new batch." };
      return data;
    } catch (error) {
      throw new Error("Failed to fetch batch: " + error.message);
    }
  },

 
};
export default batchSerice;
